import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("agt_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const CATEGORIES = [
  { key: "women", label: "Femmes", color: "#ec4899", tw: "pink" },
  { key: "men", label: "Hommes", color: "#10b981", tw: "emerald" },
  { key: "lingerie", label: "Lingerie", color: "#f97316", tw: "orange" },
  { key: "sports", label: "Sport", color: "#eab308", tw: "yellow" },
  { key: "furniture", label: "Mobilier", color: "#8b5cf6", tw: "violet" },
  { key: "associations", label: "Associations", color: "#3b82f6", tw: "blue" },
];

export const catByKey = (k) => CATEGORIES.find((c) => c.key === k) || CATEGORIES[0];
